export default __webpack_public_path__ + "static/media/Placeholder_Image.05aecb2b.svg";